import React from 'react';
import { OnboardingWrapper } from '../../../components';

import './WelcomePage.scss';
import { useOnboarding } from '../../../data-access';
import webMobileAiVideo from '../../../assets/demo/web-mobile-ai.mp4';

const WelcomePage: React.FC = () => {
  const { goToNextStep, goToSpecificStep, currentOnboardingStep } = useOnboarding();

  return (
    <OnboardingWrapper
      currentOnboardingStep={currentOnboardingStep}
      title={`Get More Done without \n Burning Out`}
      subTitle="Better daily planning with wearable data."
      buttons={[
        {
          text: 'Get started',
          onPress: goToNextStep,
          variant: 'contained',
        },
      ]}
      belowButtons={
        <p className="welcome-page__trial-note">
          Lifestack is a paid app with a 7-day free trial ($10/mo, $50/yr, $120/lifetime)
        </p>
      }
      showSignIn
      onSignIn={() => goToSpecificStep('GET_STARTED')}
      contentContainerStyle={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      hideBackButton
    >
      <video
        className="welcome-page__video"
        src={webMobileAiVideo}
        autoPlay
        loop
        muted
        playsInline
      />
    </OnboardingWrapper>
  );
};

export default WelcomePage;
